<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="management.accessory.index">
        <template v-slot:title>
          <span>{{ $t(id != null ? 'accessory.edit_accessory' : 'accessory.create_accessory') }}</span>
        </template>
        <template v-slot:preview>
          <div class="row d-flex" v-if="accessoryProxy">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12"
                 v-for="(value, index) in accessoryProxy.translations">
              <text-input
                  :key="index"
                  :title="`${$t('accessory.accessory_name')}(${getLanguageById(value.language_id).name})`"
                  :model.sync="value.name"
                  :placeholder="`${$t('accessory.please_enter_accessory_name')}(${getLanguageById(value.language_id).name})`"
                  :is-valid="value != null && value.name.length !== 0 ? true : null"
              ></text-input>

            </div>

            <div class="col-xl-6">
              <div class="d-flex items-end justify-content-start">
                <custom-multi-select
                    :title="$t('expense.expense_logo_name')"
                    :model.sync="logo_id"
                    :options="convertArrayToObjectByKey(logoItems, 'logicalref', 'name')"
                    name="accessory_logo_name"
                    :not-list="true"
                    :is-inline="true"
                    :max="1"
                    :required="true"
                    :item-per-row="1"
                    input-width="auto"
                    input-max-width="200px"
                ></custom-multi-select>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center mt-5">
            <button-with-icon
                class="mr-3 danger-border-1px"
                @onClick="$router.go(-1)"
                :text="$t('general.cancel')"
                size="lg"
                :icon-name="null"
            ></button-with-icon>
            <button-with-icon
                @onClick="createOrUpdateAccessory"
                :text="$t(id != null ? 'general.save' : 'general.create')"
                size="lg"
                :icon-name="null"
                :disabled="!isValidToCreate"
            ></button-with-icon>
          </div>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {mapMutations, mapGetters} from 'vuex'
import {
  CREATE_ITEM,
  CURRENT_ITEM,
  ERROR, GET_ITEMS,
  ITEMS,
  GET_ITEM_DETAIL_BY_ID,
  LOADING, SET_CURRENT_ITEM, SUCCESS, UPDATE_ITEM_BY_ID
} from "@/core/services/store/panel-managment/crud/panel.management.module";
import TextInput from "@/assets/components/inputs/TextInput";
import SelectInput from "@/assets/components/inputs/SelectInput";
import CustomMultiSelect from "@/assets/components/inputs/CustomMultiSelect";
import {LANGUAGE} from "@/core/services/store/system-options.module";
import ButtonWithIcon from "@/assets/components/widget/ButtonWithIcon";

export default {
  name: "AccessoryCreateEdit",
  components: {
    ButtonWithIcon,
    TextInput,
    SelectInput,
    CustomMultiSelect,
    DashboardBox
  },
  computed: {
    ...mapGetters({
      loading: LOADING,
      error: ERROR,
      success: SUCCESS,
      accessory: CURRENT_ITEM,
      language: LANGUAGE,
    }),
    isValidToCreate() {
      if (this.accessory == null || this.accessory.translations == null || this.accessory.translations.length === 0) return false;

      for (let i = 0; i < this.accessory.translations.length; i++) {
        if (this.accessory.translations[i].name == null || this.accessory.translations[i].name.length === 0) {
          return false;
        }
      }

      return true;
    },
    accessoryProxy: {
      get() {
        if (this.id != null && this.accessory) {
          this.logo_id = this.accessory.logo_id;
          this.logoItems = this.accessory.cache_items;
        }

        return this.accessory;
      },
      set(value) {
        this.setAccessory(value);
      }
    }
  },
  data() {
    return {
      id: null,
      languages: [],
      logoItems: [],
      logo_id: this.id ? this.accessoryProxy.logo_id : null,
      tempItem: {
        translations: []
      }
    };
  },
  methods: {
    ...mapMutations({
      setAccessory: SET_CURRENT_ITEM,
    }),
    getCacheData () {
      let payload = {
        url: 'api/accessories/cache-data',
        returnType: "stateless"
      }

      this.$store.dispatch(GET_ITEMS, payload).then(response => {

        if (response.status) {
          this.logoItems = response.data;
        }
      })
    },
    createOrUpdateAccessory() {

      let contents = [];

      // this.accessoryProxy.accessory_translations.forEach(r => contents.push({
      //   language_code: r.language_code,
      //   translations: {name: r.name,}
      // }))

      this.accessoryProxy.translations.forEach(item => {
        contents.push(item)
      })

      let payload = {
        url: this.id == null ? 'api/accessories' : 'api/accessories/' + this.id,
        id: this.id,
        contents: {
          translations: contents,
          logo_id: this.logo_id
        },
        redirectRouteName: 'management.accessory.index',
        successMessage: this.$t(this.id == null ? 'general.successfully_created' : 'general.successfully_updated'),
      }
      this.$store.dispatch(this.id == null ? CREATE_ITEM : UPDATE_ITEM_BY_ID, payload);

    },
  },
  mounted() {
    this.id = this.$route.params.id;

    this.getCacheData();

    if (this.id != null) {
      let payload = {
        url: 'api/accessories/' + this.id,
        id: this.id,
        redirectRouteOnNotFound: 'management.accessory.index'
      }

      this.$store.dispatch(GET_ITEM_DETAIL_BY_ID, payload)
    }

    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t("general.dashboard"), route: "dashboard"},
      {title: this.$t("accessory.accessories"), route: "management.accessory.index"},
      {title: this.$t(this.id != null ? "accessory.edit_accessory" : "accessory.create_accessory")},
    ]);


    this.languages = this.convertArrayToObjectByKey((this.systemLanguages), 'id', 'name');

    if(!this.id){
      let languages = this.systemLanguages;
      let self = this;

      languages.forEach(item => {
        self.tempItem.translations.push({
          language_id: item.id,
          name: "",
        })
      })
      this.setAccessory(self.tempItem)
    }
  }
}
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}
</style>
